import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';
import InfoIconMDI from 'mdi-react/InformationOutlineIcon';

type PriceNoticeProps = {
  hideText?: boolean;
  color?: string;
};

export const Text = styled.span`
  padding-left: 2px;
`;

export const InfoIcon = styled(InfoIconMDI)(
  props => css`
    color: ${props.theme.icons.quaternary};
  `
);

export const PriceNotice = styled.div<PriceNoticeProps>(
  props => css`
    display: flex;
    align-items: center;
    color: ${props.theme.icons.primary};

    ${props.hideText &&
      css`
        ${media.smallOnly`
          margin-right: 2px;
        `}

        ${Text} {
          display: none;
        }
      `};
    ${props.color === 'dark' &&
      css`
        color: ${props.theme.text.tertiary};

        ${InfoIcon} {
          color: ${props.theme.icons.secondary};
        }
      `}
  `
);
